import axios from "axios";

const HandlePhotoChange = async (data, token, setImagePath, setMsg) => {
    const url = "https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile";

    const headerss = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
    }

    try {
        const res = await axios({
            method: 'Post',
            url: url,
            params: { mediaType: "photo" },
            data: data,
            headers: headerss
        });

        if (res.status === 200 && res.data.success) {
            setImagePath("https://api.heryerdeingilizce.com/" + res.data.data.path);
            return true;
        }

        setMsg(res.data?.message || "Yükleme başarısız.");
        return false;

    } catch (err) {
        setMsg(err.message);
        return false;
    }
}

export default HandlePhotoChange;